import React from 'react';
import PropTypes from 'prop-types';

import {
    Flex, Label, Radio,
} from '@zillow/constellation';
import { Col, Row } from '@zillow/zrs-comet';

import { StyledContainer } from './StyledComponents';

const propTypes = {
    label: PropTypes.node.isRequired,
    description: PropTypes.node.isRequired,
    helperText: PropTypes.node.isRequired,
    name: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};
const defaultProps = {};

const RadioButton = ({
    label, description, helperText, checked, name, id, onClick,
}) => (
    <Flex display="flex" justifyContent="center" alignItems="center" flexDirection="column">
        <StyledContainer paddingY="md" onClick={onClick} for={id}>
            <Row noMargin={true}>
                <Col xs={1} alignVertical="center"><Radio name={name} id={id} checked={checked} /></Col>
                <Col xs={description ? 5 : 11}>
                    <Label size="lg">{label}</Label>
                </Col>
                <Col xs={6}>{description}</Col>
            </Row>
        </StyledContainer>
        {helperText}
    </Flex>
);

RadioButton.propTypes = propTypes;
RadioButton.defaultProps = defaultProps;

export default RadioButton;
